import { render, staticRenderFns } from "./Ptp.vue?vue&type=template&id=4ae4a46b"
import script from "./Ptp.vue?vue&type=script&lang=js"
export * from "./Ptp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports